export default __webpack_public_path__ + "static/media/arrow-circle-left.b6d741ac.svg";